import { render, staticRenderFns } from "./_betListDC.vue?vue&type=template&id=0b119229&lang=pug&"
import script from "./_betListDC.vue?vue&type=script&lang=js&"
export * from "./_betListDC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports